import HStack from "shared/components/layout/stack/HStack";
import Icon from "shared/components/utils/Icon";
import TextArea from "shared/components/inputs/form-fields/TextArea";
import VStack from "shared/components/layout/stack/VStack";
import styled from "styled-components";

export const StyledVStack = styled(VStack)`
    padding: 24px 0px;
    gap: 24px;
`;

export const OptionsWrapper = styled.div`
    margin-bottom: 2rem;
`;

export const StyledTextArea = styled(TextArea)`
    gap: 16px;
    textarea {
        min-height: 160px;
    }
`;

export const SupportWrapper = styled(VStack)`
    margin-top: 1rem;
`;

export const TalentSupportMail = styled(HStack)`
    cursor: pointer;
    padding-right: 6px;
`;

export const StyledIcon = styled(Icon)`
    align-self: center;
`;
